// Models
import Model from './Model'

class Deposit extends Model {
  get isNew () {
    return this.status === DEPOSIT_STATUSES.NEW
  }

  get isOpened () {
    return this.status === DEPOSIT_STATUSES.OPENED
  }

  get isCompleted () {
    return this.status === DEPOSIT_STATUSES.COMPLETED
  }

  get isTerminated () {
    return this.status === DEPOSIT_STATUSES.TERMINATED
  }

  static get statusOptions () {
    return [
      { name: 'New', value: DEPOSIT_STATUSES.NEW },
      { name: 'Opened', value: DEPOSIT_STATUSES.OPENED },
      { name: 'Completed', value: DEPOSIT_STATUSES.COMPLETED },
      { name: 'Terminated', value: DEPOSIT_STATUSES.TERMINATED }
    ]
  }

  get schema () {
    return [
      'accountId',
      'amount',
      'clientRequestId',
      'createdAt',
      'currency',
      'expirationDate',
      'finishedAt',
      'id',
      'interestRate',
      'maturity',
      'openingDate',
      'profileId',
      'profit',
      'status',
      'paymentId'
    ]
  }
}

export const DEPOSIT_STATUSES = {
  DRAFT: 'DRAFT',
  NEW: 'NEW',
  OPENED: 'OPENED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED',
  TERMINATED: 'TERMINATED'
}

export default Deposit
